import { constantes } from './../../constantes';
import { environment } from '../../../environments/environment';
import { ParamsService } from '../../services/params.service';
import { DataService } from '../../services/data.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ApplicationRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';


@Component({
  selector: 'app-page-route',
  templateUrl: './page-route.component.html',
  styleUrls: ['./page-route.component.scss']
})
export class PageRouteComponent implements OnInit {

	
	@ViewChild('textInput1') textInput1:ElementRef;
	@ViewChild('textInput2') textInput2:ElementRef;
	@ViewChild('outputPanel') outputPanel:ElementRef;
	
	autocomplete1:google.maps.places.Autocomplete;
	autocomplete2:google.maps.places.Autocomplete;
	// directionsService:google.maps.DirectionsService;
	directionsService:any;
	directionsDisplay:any;
	directionRoute:google.maps.DirectionsRoute;
	
	markerA:google.maps.Marker;
	markerB:google.maps.Marker;
	polyline:google.maps.Marker;
	
	customizeDirectionsStep:boolean = true;
	// customizeDirectionsStep:boolean = false;
	
	form:FormGroup;
	subtry:boolean;
	
	
	mode:string = '';
	
  constructor(
		private _fb:FormBuilder,
		public dataService:DataService,
		private paramsService:ParamsService,
		private app: ApplicationRef,
		
	) { }

	
	
	
  ngOnInit() {
		
		let validation:any =null;
		
		this.mode = 'driving';
		
		
		let icon:google.maps.Icon = {
				url: 'assets/images/markers/' + 'route-marker' + '.png',
				size: new google.maps.Size(37, 36),
				scaledSize: new google.maps.Size(37, 36),
				anchor: new google.maps.Point(19, 18),
		};
		let symbol:google.maps.Symbol = {
				fillColor: '#4F80C1',
				strokeColor: 'white',
				strokeWeight: 2,
		};
		
		let rendererOptions:any = {
			preserveViewport: true,
			suppressMarkers: true,
			
			suppressBicyclingLayer: true,
			
			polylineOptions: {
				strokeColor: '#4F80C1',
				strokeOpacity: 1.0,
				strokeWeight: 5
			},
			/* 
			markerOptions:{
				icon: icon
			}
			 */
			
		};
		
		this.directionsService = new google.maps.DirectionsService();
		
		this.directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions);
		
		
		
		
		if(!this.customizeDirectionsStep){
			this.directionsDisplay.setPanel(this.outputPanel.nativeElement);
		}
		
		
		let dest:string = this.paramsService.getData('itineraireDest') || '';
		let departure:string = '';
		console.log('dest : '+dest);
		// debugger;
		/* 
		if(environment.debug){
			departure = '19 rue des bateliers STRASBOURG';
			dest = 'place de bordeaux strasbourg';
		}
		*/
		
		//geolocation
		let userAddress:string = constantes.userAddress;
		
		if(constantes.userAddress){
			departure = constantes.userAddress;
			console.log('constantes.userAddress defined');
		}
		else if (navigator.geolocation) {
			
			console.log('getCurrentPosition');
			
			//ie 11 marche pas
			//https://stackoverflow.com/questions/43206442/geolocation-current-position-api-not-working-in-ie11-5-windows10
			
			var options = { enableHighAccuracy: true, maximumAge: 100, timeout: 60000 };
			
      navigator.geolocation.getCurrentPosition((position) => {
				
				console.log('position : '+position);
				//position.coords : latitude, longitude
				let latlng:google.maps.LatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
				
				var geocoder = new google.maps.Geocoder;
				geocoder.geocode({'location': latlng}, function(results, status){
					
          if (results && results[0]) {
						constantes.userAddress = results[0].formatted_address;
						console.log('userAddress : '+constantes.userAddress);
						this.form.patchValue({departure: constantes.userAddress});
						this.app.tick();
					}
				}.bind(this));
      }, function(error){
				//debugger;
			}, options);
    }
		
		
		this.form = this._fb.group({
			departure: [departure, validation],
			destination: [dest, validation],
		});
		
		
		this.paramsService.addListener('route', this.onClickRoute.bind(this));
		/* 
		setTimeout(function() {
			this.textInput1.nativeElement.focus();
		}.bind(this), 500);
		 */
		
		this.autocomplete1 = this.autocomplete(this.textInput1.nativeElement);
		this.autocomplete2 = this.autocomplete(this.textInput2.nativeElement);
		
		
	}
	
	
	autocomplete(input:any):google.maps.places.Autocomplete
	{
		let options:any = {
			/* 
			bounds: new google.maps.LatLngBounds(
				new google.maps.LatLng(48.242281,7.001274),		//south-west
				new google.maps.LatLng(49.019184,8.528994)		//north-east
			),
			strictBounds: true,
			 */
		};
		
		var autocomplete:any = new google.maps.places.Autocomplete(input, options);
		autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
		
		return autocomplete;
	}
	
	
	clickMode(mode:string):void
	{
		this.mode = mode;
	}

	invert():void
	{
		let place1:google.maps.places.PlaceResult = this.autocomplete1.getPlace();
		let place2:google.maps.places.PlaceResult = this.autocomplete2.getPlace();
		
		let departure:any = (place1 && this.extractAddress(place1)) || this.form.value.departure;
		let destination:any = (place2 && this.extractAddress(place2)) || this.form.value.destination;
		
		// debugger;
		
		this.form.setValue({
			departure: destination,
			destination: departure,
		});
		
		let autocomplete1 = this.autocomplete1;
		this.autocomplete1 = this.autocomplete2;
		this.autocomplete2 = autocomplete1;
	}
	
	
	
	erase(key:string):void
	{
		this.form.controls[key].setValue('');
	}
	
	
	
	valid():void
	{
		let place1:any = this.autocomplete1.getPlace();
		let place2:any = this.autocomplete2.getPlace();
		
		
		/* 
		//marche pas non plus
		debugger;
		this.dataService.showRoute = true;
		if(this.dataService) return;
		 */
		
		let departure:any = (place1 && this.extractAddress(place1)) || this.form.value.departure;
		let destination:any = (place2 && this.extractAddress(place2)) || this.form.value.destination;
		
		if(departure && destination){
			let travelMode:any;
			if(this.mode == 'driving') travelMode = google.maps.TravelMode.DRIVING;
			else if(this.mode == 'bicycling') travelMode = google.maps.TravelMode.BICYCLING;
			else if(this.mode == 'transit') travelMode = google.maps.TravelMode.TRANSIT;
			else if(this.mode == 'walking') travelMode = google.maps.TravelMode.WALKING;
			
			var request:google.maps.DirectionsRequest = {
				origin: departure,
				destination: destination,
				travelMode: travelMode,
			};
			
			// debugger;
			
			this.directionsService.route(request, function(result:google.maps.DirectionsResult, status) {
				
				let directionRoute:google.maps.DirectionsRoute;
				if (status == 'OK') {
					
					if(this.markerA) this.markerA.setMap(null);
					if(this.markerB) this.markerB.setMap(null);
					if(this.polyline) this.polyline.setMap(null);
					
					this.directionsDisplay.setMap(this.dataService.map);
					
					let path = this.extractPathFromLeg(result.routes[0].legs);
					let polyline = new google.maps.Polyline({
						path: path,
						geodesic: true,
						strokeColor:'white',
						strokeWeight:9, 
					});
					polyline.setMap(this.dataService.map);
					this.polyline = polyline;
					
					let symbol:google.maps.Symbol = {
							fillColor: '#4F80C1',
							fillOpacity: 1.0,
							strokeColor: 'white',
							strokeWeight: 2,
							path:google.maps.SymbolPath.CIRCLE,
							scale:10,
					};
							
					let marker:google.maps.Marker = new google.maps.Marker({
						position: path[0],
						icon: symbol,
						label: {
							color:'white',
							// fontWeight:'bold',
							text:'A',
						}
					});
					marker.setMap(this.dataService.map);
					this.markerA = marker;
					
					
					marker = new google.maps.Marker({
						position: path[path.length - 1],
						icon: symbol,
						label: {
							color:'white',
							// fontWeight:'bold',
							text:'B',
						}
					});
					marker.setMap(this.dataService.map);
					this.markerB = marker;
					
					
					
					//debugger;
					this.dataService.showRoute = true;
						
					
					this.directionsDisplay.setDirections(result);
					this.directionRoute = result.routes[0];
					directionRoute = this.directionRoute;
					
					let latlng1:google.maps.LatLng = directionRoute.bounds.getNorthEast();
					let latlng2:google.maps.LatLng = directionRoute.bounds.getSouthWest();
					let latlng:google.maps.LatLng = new google.maps.LatLng(
						(latlng1.lat() + latlng2.lat()) * 0.5,
						(latlng1.lng() + latlng2.lng()) * 0.5,
					);
					
					//todo calculate with window width
					//(width - sidebar) * 0.5
					//todo : only if desktop
					
					this.dataService.map.setZoom(12);
					latlng = this.getOffsetCenter(this.dataService.map, latlng, 150, 0);
					
					this.dataService.map.panTo(latlng);
					
					this.app.tick();
					/* 
					setTimeout(function() {
						this.app.tick();
					}.bind(this), 1000);
					*/
					
					// debugger;
				}
			}.bind(this));
			
		}
		
	}
	
	
	
	extractPathFromLeg(legs:any[]):google.maps.LatLng[]
	{
		let output:google.maps.LatLng[] = [];
		
		for (let i=0;i<legs.length;i++) {
			let steps = legs[i].steps;
			for (let j=0;j<steps.length;j++) {
				let nextSegment = steps[j].path;
				for (let k=0;k<nextSegment.length;k++) {
					output.push(nextSegment[k]);
				}
			}
		}
		return output;
	}
	
	
	
	
	showRouteChanged(value:boolean):void
	{
		this.dataService.showRoute = !this.dataService.showRoute;
		let map:any = this.dataService.showRoute ? this.dataService.map : null;
		//debugger;
		this.directionsDisplay.setMap(map);
		if(this.markerA) this.markerA.setMap(map);
		if(this.markerB) this.markerB.setMap(map);
		if(this.polyline) this.polyline.setMap(map);
	}
	
	
	
	
	
	
	
	//todo : move dans service spécialisé calcul 
	
	getOffsetCenter(map:google.maps.Map, latlng:google.maps.LatLng, offsetx:number, offsety:number) :google.maps.LatLng
	{
			// latlng is the apparent centre-point
			// offsetx is the distance you want that point to move to the right, in pixels
			// offsety is the distance you want that point to move upwards, in pixels
			// offset can be negative
			// offsetx and offsety are both optional
	
			var scale = Math.pow(2, map.getZoom());
	
			var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
			var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);
	
			var worldCoordinateNewCenter = new google.maps.Point(
					worldCoordinateCenter.x - pixelOffset.x,
					worldCoordinateCenter.y + pixelOffset.y
			);
	
			var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
			// debugger;
			return newCenter;
		
	}
	
	
	
	
	
	extractAddress(place:any):string
	{
		return place.address_components.reduce((accumulator, curvalue) => {
			return accumulator + curvalue.short_name + ' ';
		},'');
	}
	
	
	onClickRoute(data:any):void
	{
		//debugger;
		// this.form.value.destination = data.address;
		this.form.patchValue({destination: data.address || data.desc});
		this.app.tick();
	}
	
}
